import React, { useState, useEffect, useContext, createContext } from "react";
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";
import { sendAnnulmentOperation } from "../../../apis/apis.logistics/apisProduct";
import { ContextAuth } from "../../../contexts/ContextAuth";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Swal from "sweetalert2";

export function PurchaseList({ orders, setDetailsFromOrderPurchaseReceived }) {
    const { auth } = useContext(ContextAuth);
    const [isDropdownOpen, setIsDropdownOpen] = useState(null);
    
    const sendAnnulment = async (data) => {
        try {
            const response = await sendAnnulmentOperation(data);
            return response;
        } catch (error) {
            throw error;
        }
    };
    
    const handleAnnulment = async (order) => {
        Swal.fire({
            title: "¿Esta usted seguro?",
            text: "¿Anular la compra?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#dc2626",
            cancelButtonColor: "#6b7280",
            confirmButtonText: "Sí, anular",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                await sendAnnulment({
                    operationID: order.operationID,
                    userID: auth.data.user_id,
                }).then((r) => {
                    if (r.status == 201) {
                        toast.success("Operacion anulada con exito!");
                    } else {
                        toast.error("Ocurrio algun error");
                    }
                });
            }
        });
    };
    
    const getRowClass = (status) => {
        switch(status) {
            case "03": return "bg-red-50 dark:bg-red-900/20";
            case "02": return "bg-gray-50 dark:bg-gray-700/30";
            default: return "bg-blue-50 dark:bg-blue-900/20";
        }
    };
    
    const totalCompleted = Number(orders.filter((o => o.operationDocumentTypeID == "03" && o.operationStatus == "02")).reduce((previousValue, currentValue) => previousValue + currentValue.operationAmountTotal, 0)).toFixed(2);
    const totalAnnulled = Number(orders.filter((o => o.operationDocumentTypeID == "03" && o.operationStatus == "03")).reduce((previousValue, currentValue) => previousValue + currentValue.operationAmountTotal, 0)).toFixed(2);
    const totalCreditNotes = Number(orders.filter((o => o.operationDocumentTypeID == "06")).reduce((previousValue, currentValue) => previousValue + currentValue.operationAmountTotal, 0)).toFixed(2);
    const totalFreeCompleted = Number(orders.filter((o => o.operationDocumentTypeID == "03" && o.operationStatus == "02")).reduce((previousValue, currentValue) => previousValue + (currentValue.operationAmountFree || 0), 0)).toFixed(2);
    
    return (
        <div className="mb-6">
            <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm overflow-hidden mb-6">
                {/* Desktop View - Table */}
                <div className="hidden md:block overflow-x-auto">
                    <table className="w-full text-sm text-left" id="table-to-xls">
                        <thead className="bg-gray-900 text-gray-100">
                            <tr className="text-uppercase">
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">#</th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">Estado</th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">Tip Doc</th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">Documento</th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">Fecha</th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">Ruc</th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">Proveedor</th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">Articulos</th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">OP. GRAVADAS</th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">I.G.V.</th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">TOTAL VENTA</th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">GRATUITO</th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">ACCIONES</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                            {orders.map((o, index) => (
                                <tr key={index} className={`${getRowClass(o.operationStatus)} hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors`}>
                                    <td className="px-4 py-3 text-center text-gray-900 dark:text-white">{o.operationID}</td>
                                    <td className="px-4 py-3 text-center text-gray-900 dark:text-white">{o.operationStatusDisplay}</td>
                                    <td className="px-4 py-3 text-center text-gray-900 dark:text-white">{o.operationDocumentDisplay}</td>
                                    <td className="px-4 py-3 text-center text-gray-900 dark:text-white">{o.operationDocumentNumber}</td>
                                    <td className="px-4 py-3 text-center text-gray-900 dark:text-white">{o.operationDate}</td>
                                    <td className="px-4 py-3 text-center text-gray-900 dark:text-white">{o.supplierDocumentNumber}</td>
                                    <td className="px-4 py-3 text-center text-gray-900 dark:text-white">{o.supplierName}</td>
                                    <td className="px-4 py-3 text-center text-gray-900 dark:text-white">{o.operationNumberItems}</td>
                                    <td className="px-4 py-3 text-right text-gray-900 dark:text-white whitespace-nowrap">S/ {Number(o.operationAmountBase).toFixed(2)}</td>
                                    <td className="px-4 py-3 text-right text-gray-900 dark:text-white whitespace-nowrap">S/ {Number(o.operationAmountIgv).toFixed(2)}</td>
                                    <td className="px-4 py-3 text-right text-gray-900 dark:text-white whitespace-nowrap">S/ {Number(o.operationAmountTotal).toFixed(2)}</td>
                                    <td className="px-4 py-3 text-right whitespace-nowrap">
                                        {Number(o.operationAmountFree || 0) > 0 ? (
                                            <span className="text-amber-600 dark:text-amber-400 font-medium">
                                                <i className="fas fa-gift mr-1"></i>
                                                S/ {Number(o.operationAmountFree).toFixed(2)}
                                            </span>
                                        ) : (
                                            <span className="text-gray-400 dark:text-gray-500">-</span>
                                        )}
                                    </td>
                                    <td className="px-4 py-3 text-center">
                                        {o.operationDocumentTypeID == "03" ? (
                                            <div className="relative inline-block">
                                                <button 
                                                    type="button" 
                                                    className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
                                                    onClick={() => setIsDropdownOpen(isDropdownOpen === index ? null : index)}
                                                >
                                                    Acciones
                                                    <i className="fas fa-chevron-down text-xs"></i>
                                                </button>
                                                {isDropdownOpen === index && (
                                                    <div className="absolute right-0 z-10 mt-2 w-48 rounded-lg bg-white dark:bg-gray-700 shadow-lg border border-gray-200 dark:border-gray-600">
                                                        <div className="py-1">
                                                            <button 
                                                                className="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 flex items-center gap-2"
                                                                onClick={() => {
                                                                    handleAnnulment(o);
                                                                    setIsDropdownOpen(null);
                                                                }}
                                                            >
                                                                <i className="fas fa-ban"></i> Anular
                                                            </button>
                                                            <Link 
                                                                to={"/buys/edit_order_purchase_received/" + o.operationID} 
                                                                className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 flex items-center gap-2"
                                                                onClick={() => setIsDropdownOpen(null)}
                                                            >
                                                                <i className="fas fa-archive"></i> Editar vencimiento
                                                            </Link>
                                                            <button 
                                                                className="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 flex items-center gap-2"
                                                                onClick={() => {
                                                                    setDetailsFromOrderPurchaseReceived(o.operationItems);
                                                                    setIsDropdownOpen(null);
                                                                    document.getElementById("modal-order-purchase-received").click();
                                                                }}
                                                            >
                                                                <i className="fas fa-highlighter"></i> Ver Detalles
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        ) : null}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot className="bg-gray-50 dark:bg-gray-700/30">
                            <tr>
                                <td className="px-4 py-3 text-right font-semibold text-gray-900 dark:text-white" colSpan={10}>Total facturas completadas</td>
                                <td className="px-4 py-3 text-right font-semibold text-gray-900 dark:text-white whitespace-nowrap">S/ {totalCompleted}</td>
                                <td colSpan={2}></td>
                            </tr>
                            <tr>
                                <td className="px-4 py-3 text-right font-semibold text-gray-900 dark:text-white" colSpan={10}>Total facturas anuladas</td>
                                <td className="px-4 py-3 text-right font-semibold text-gray-900 dark:text-white whitespace-nowrap">S/ {totalAnnulled}</td>
                                <td colSpan={2}></td>
                            </tr>
                            <tr>
                                <td className="px-4 py-3 text-right font-semibold text-gray-900 dark:text-white" colSpan={10}>Total notas de Credito</td>
                                <td className="px-4 py-3 text-right font-semibold text-gray-900 dark:text-white whitespace-nowrap">S/ {totalCreditNotes}</td>
                                <td colSpan={2}></td>
                            </tr>
                            <tr>
                                <td className="px-4 py-3 text-right font-semibold text-amber-700 dark:text-amber-400" colSpan={11}>
                                    <i className="fas fa-gift mr-1"></i>
                                    Total Gratuito (facturas completadas)
                                </td>
                                <td className="px-4 py-3 text-right font-semibold text-amber-700 dark:text-amber-400 whitespace-nowrap">S/ {totalFreeCompleted}</td>
                                <td colSpan={1}></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                
                {/* Mobile View - Cards */}
                <div className="md:hidden">
                    {orders.map((o, index) => (
                        <div key={index} className={`p-4 border-b border-gray-200 dark:border-gray-700 last:border-b-0 ${getRowClass(o.operationStatus)}`}>
                            <div className="flex justify-between items-start mb-3">
                                <div>
                                    <span className="text-xs text-gray-500 dark:text-gray-400">#{o.operationID}</span>
                                    <h4 className="font-semibold text-gray-900 dark:text-white">{o.supplierName}</h4>
                                    <p className="text-sm text-gray-600 dark:text-gray-400">{o.operationDocumentDisplay} {o.operationDocumentNumber}</p>
                                </div>
                                <span className="text-sm text-gray-600 dark:text-gray-400">{o.operationStatusDisplay}</span>
                            </div>
                            <div className="grid grid-cols-2 gap-2 text-sm mb-3">
                                <div>
                                    <span className="text-gray-500 dark:text-gray-400 text-xs uppercase">Fecha</span>
                                    <p className="text-gray-900 dark:text-white">{o.operationDate}</p>
                                </div>
                                <div>
                                    <span className="text-gray-500 dark:text-gray-400 text-xs uppercase">Ruc</span>
                                    <p className="text-gray-900 dark:text-white">{o.supplierDocumentNumber}</p>
                                </div>
                                <div>
                                    <span className="text-gray-500 dark:text-gray-400 text-xs uppercase">Articulos</span>
                                    <p className="text-gray-900 dark:text-white">{o.operationNumberItems}</p>
                                </div>
                                <div>
                                    <span className="text-gray-500 dark:text-gray-400 text-xs uppercase">Total</span>
                                    <p className="text-gray-900 dark:text-white font-semibold">S/ {Number(o.operationAmountTotal).toFixed(2)}</p>
                                </div>
                                {Number(o.operationAmountFree || 0) > 0 && (
                                    <div>
                                        <span className="text-gray-500 dark:text-gray-400 text-xs uppercase">Gratuito</span>
                                        <p className="text-amber-600 dark:text-amber-400 font-semibold">
                                            <i className="fas fa-gift mr-1"></i>
                                            S/ {Number(o.operationAmountFree).toFixed(2)}
                                        </p>
                                    </div>
                                )}
                            </div>
                            {o.operationDocumentTypeID == "03" && (
                                <div className="flex flex-wrap gap-2">
                                    <button 
                                        className="inline-flex items-center gap-1 px-3 py-1.5 text-sm font-medium rounded-lg text-red-700 dark:text-red-300 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 hover:bg-red-100 dark:hover:bg-red-900/50 transition-colors"
                                        onClick={() => handleAnnulment(o)}
                                    >
                                        <i className="fas fa-ban"></i> Anular
                                    </button>
                                    <Link 
                                        to={"/buys/edit_order_purchase_received/" + o.operationID} 
                                        className="inline-flex items-center gap-1 px-3 py-1.5 text-sm font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-gray-700/30 border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors"
                                    >
                                        <i className="fas fa-archive"></i> Editar
                                    </Link>
                                    <button 
                                        className="inline-flex items-center gap-1 px-3 py-1.5 text-sm font-medium rounded-lg text-blue-700 dark:text-blue-300 bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-800 hover:bg-blue-100 dark:hover:bg-blue-900/50 transition-colors"
                                        onClick={() => {
                                            setDetailsFromOrderPurchaseReceived(o.operationItems);
                                            document.getElementById("modal-order-purchase-received").click();
                                        }}
                                    >
                                        <i className="fas fa-highlighter"></i> Ver
                                    </button>
                                </div>
                            )}
                        </div>
                    ))}
                    
                    {/* Mobile Totals */}
                    <div className="p-4 bg-gray-50 dark:bg-gray-700/30 space-y-2">
                        <div className="flex justify-between">
                            <span className="font-semibold text-gray-700 dark:text-gray-300">Total facturas completadas</span>
                            <span className="font-semibold text-gray-900 dark:text-white">S/ {totalCompleted}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="font-semibold text-gray-700 dark:text-gray-300">Total facturas anuladas</span>
                            <span className="font-semibold text-gray-900 dark:text-white">S/ {totalAnnulled}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="font-semibold text-gray-700 dark:text-gray-300">Total notas de Credito</span>
                            <span className="font-semibold text-gray-900 dark:text-white">S/ {totalCreditNotes}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="font-semibold text-amber-700 dark:text-amber-400">
                                <i className="fas fa-gift mr-1"></i>
                                Total Gratuito (completadas)
                            </span>
                            <span className="font-semibold text-amber-700 dark:text-amber-400">S/ {totalFreeCompleted}</span>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Action Buttons */}
            <div className="flex flex-wrap gap-3">
                <Link 
                    to='/buys/new_purchase_order' 
                    className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
                >
                    <i className="fas fa-plus"></i>
                    Nueva orden de compra
                </Link>
                <button
                    className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
                    data-toggle="modal"
                    data-target="#modal-note-credit"
                >
                    <i className="fas fa-plus"></i>
                    Nota de credito
                </button>
                <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
                    table="table-to-xls"
                    filename="reporte_compras"
                    sheet="report"
                    buttonText="Descargar como XLS"
                />
            </div>
        </div>
    )
}
